
module dgUtils {

    function dgDate($filter: dgUtils.IFilterService): Function {
        return theDate => $filter('date')(theDate, 'dd/MM/yyyy');
    }

    angular.module('dgUtils')
        .filter('dgDate', dgDate);
}